/**
 * ContentArea Component
 * 
 * React equivalent would be:
 * function ContentArea({ newsData, rows = 17 }) {
 *   return (
 *     <main className="content-area">
 *       <div className="content-wrapper">
 *         {Array.from({ length: rows }).map((_, i) => (
 *           <NewsRow key={i} rowIndex={i} data={newsData} />
 *         ))}
 *       </div>
 *       <Footer />
 *     </main>
 *   );
 * }
 */
import { newsHeadlines, countries, cardGradients } from '../data/newsData.js';

// Configuration for specific rows
const rowConfig = {
    0: {
        id: 'wslnews',
        logo: '/images/league_wsl.png',
        flag: '/images/flags/uk.png',
        prefix: 'wsl'
    },
    1: {
        id: 'nwsl',
        logo: '/images/league_nwsl.png',
        flag: '/images/flags/usa.png',
        prefix: 'nwsl'
    },
    2: {
        id: 'apl',
        logo: '/images/league_apl.png',
        flag: '/images/flags/france.png',
        prefix: 'apl'
    },
    3: {
        id: 'dfb',
        logo: '/images/league_dfb.png',
        flag: '/images/flags/germany.png',
        prefix: 'dfb'
    },
    4: {
        id: 'ligaf',
        logo: '/images/league_ligaf.png',
        flag: '/images/flags/spain.png',
        prefix: 'ligaf'
    },
    5: {
        id: 'seriea',
        logo: '/images/league_seriea.png',
        flag: '/images/flags/italy.png',
        prefix: 'seriea'
    },
    6: {
        id: 'wk',
        logo: '/images/league_wk.png',
        flag: '/images/flags/skorea.png',
        prefix: 'wk'
    },
    7: {
        id: 'bpi',
        logo: '/images/league_bpi.png',
        flag: '/images/flags/portugal.png',
        prefix: 'bpi'
    },
    8: {
        id: 'brasil',
        logo: '/images/league_bra.png',
        flag: '/images/flags/brasil.png',
        prefix: 'brasil'
    },
    9: {
        id: 'ligamx',
        logo: '/images/league_ligamx.png',
        flag: '/images/flags/mexico.png',
        prefix: 'ligamx'
    },
    10: {
        id: 'nwfl',
        logo: '/images/league_nwfl.png',
        flag: '/images/flags/nigeria.png',
        prefix: 'nwfl'
    },
    11: {
        id: 'usl',
        logo: '/images/league_usl.png',
        flag: '/images/flags/usa.png',
        prefix: 'usl'
    },
    12: {
        id: 'we',
        logo: '/images/league_we.png',
        flag: '/images/flags/japan.png',
        prefix: 'we'
    },
    13: {
        id: 'saff',
        logo: '/images/league_saff.png',
        flag: '/images/flags/saudi.png',
        prefix: 'saff'
    },
    14: {
        id: 'sweden',
        logo: '/images/league_obos.png',
        flag: '/images/flags/sweden.png',
        prefix: 'sweden'
    },
    15: {
        id: 'aleague',
        logo: '/images/league_a.png',
        flag: '/images/flags/australia.png',
        prefix: 'aleague'
    },
    16: {
        id: 'world',
        logo: '/images/logo2.png',
        flag: '/images/logo2.png',
        prefix: 'world'
    }
};

// Custom Headlines for WSL (Row 0)
const wslHeadlines = [
    "Leicester City Transfer moves",
    "Tottenham Secure Blakstad",
    "Arsenal Add Swedish Teenager",
    "Manchester United Signings ",
    "Lionesses in Honours List",
    "Sarina Wiegman Wins Coach Award",
    "Rita Guarino New West Ham Manager",
    "Bournemouth criticised",
    "London City lose to Tottenham"
];

const nwslHeadlines = [
    "Sam Coffey leaves Portland Thorns", 
    "Trinity Rodman Returns", "USWNT in 2026 SheBelieves Cup",
    "Denver Signs Jasmine Aikey",
     "Ayo Oke Joins Denver Summit FC",
     "Inaugural NWSL Combine",
    "Sophia Wilson Re-Signs with Portland Thorns", 
    "NWSL High Impact Player Rule",
    "Gotham FC Wins 2025 NWSL Championship"
];

const aplHeadlines = [
    "Arkema Extends Sponsorship", 
    "Grace Geyoro Transfer Record",
    "Lyonnes Lead Arkema",
    "Brazil and France Set", 
    "France kicks off 2027", 
    "France U23s lose to England U23s",
    "High-scoring action",
    "Première Ligue attendance surge", 
    "Clairefontaine"
];

const dfbHeadlines = [
    "Giovanna Hoffmann Joins Wolfsburg", 
    "Will Selina Cerci Move to Wolfsburg", 
    "Dortmund an Option for Kellermann",
    "Grunenberg to Leave the Club",
    "... Matches Are Incredibly Fun", 
    "Klara Bühl Ruled Out",
    "Veit and Mühlhaus Called Up",
     "DFB Extends Contract of Coach Christian Wück",
     "Wolfsburg Reveal Plans"
];

const ligafHeadlines = [
    "Spanish Security Issues", 
    "Liga F Matchday Highlights",
     "Aitana Bonmatí Set for Surgery",
    "Barcelona Thrash Real Madrid",
     "Caicedo Suffers Injury", 
    "Aitana Bonmatí Wins Flashscore Award",
    "Barcelona Dispatch Valencia", 
    "Madrid Director Calls for Funding Cuts", 
    "Spain to Face Draw for UEFA Nations League"
];

const serieaHeadlines = [
    "Azzurre Gear Up for Denmark ", 
    "Embassy Leaders Attend Italy-Sweden",
     "Elisabetta Vignotto: The Italian Pioneer",
    "Italy Falls 1-0 to Sweden", 
    "Roma Edges Inter 1-0", 
    "Ternana Holds Juventus",
    "Lazio and AC Milan Share Points", 
    "Washington Spirit Duo Called Up", 
    "Patrizia Panico The Enduring Scorpion"
];

const wkHeadlines = [
    "Ahn Taehwa Rejoins Seoul Coaching Staff", 
    "Taegeuk Ladies fell 1-4 to Japan", 
    "Park Namyeol takes over at KHNP",
    "2026 WK League Full Fixtures", 
    "Mungyeong Sangmu Launch Instagram",
     "Taegeuk Ladies Qualify for 2027 World Cup",
    "2025 KWFF Youth Awards", 
    "2025 WK League Best 11",
     "4th Denso Cup Korea-Japan"
];

const bpiHeadlines = [
    "BPI Headline 1",
     "BPI Headline 2", 
    "BPI Headline 3",
    "BPI Headline 4",
     "BPI Headline 5",
     "BPI Headline 6",
    "BPI Headline 7",
     "BPI Headline 8",
     "BPI Headline 9"
];

const brasilHeadlines = [
    "Brasil Headline 1",
     "Brasil Headline 2",
      "Brasil Headline 3",
    "Brasil Headline 4",
     "Brasil Headline 5",
      "Brasil Headline 6",
    "Brasil Headline 7", 
    "Brasil Headline 8", 
    "Brasil Headline 9"
];

const ligamxHeadlines = [
    "Liga MX Headline 1",
     "Liga MX Headline 2",
      "Liga MX Headline 3",
    "Liga MX Headline 4",
     "Liga MX Headline 5",
      "Liga MX Headline 6",
    "Liga MX Headline 7",
     "Liga MX Headline 8", 
     "Liga MX Headline 9"
];

const nwflHeadlines = [
    "NWFL Headline 1", 
    "NWFL Headline 2", 
    "NWFL Headline 3",
    "NWFL Headline 4", 
    "NWFL Headline 5",
     "NWFL Headline 6",
    "NWFL Headline 7", 
    "NWFL Headline 8",
     "NWFL Headline 9"
];

const uslHeadlines = [
    "USL Headline 1",
     "USL Headline 2", 
     "USL Headline 3",
    "USL Headline 4",
     "USL Headline 5",
      "USL Headline 6",
    "USL Headline 7", 
    "USL Headline 8",
     "USL Headline 9"
];

const weHeadlines = [
    "WE League Headline 1",
     "WE League Headline 2", 
     "WE League Headline 3",
    "WE League Headline 4", 
    "WE League Headline 5", 
    "WE League Headline 6",
    "WE League Headline 7", 
    "WE League Headline 8",
     "WE League Headline 9"
];

const saffHeadlines = [
    "SAFF Headline 1", 
    "SAFF Headline 2",
     "SAFF Headline 3",
    "SAFF Headline 4",
     "SAFF Headline 5",
      "SAFF Headline 6",
    "SAFF Headline 7", 
    "SAFF Headline 8",
     "SAFF Headline 9"
];

const swedenHeadlines = [
    "Sweden Headline 1", 
    "Sweden Headline 2", 
    "Sweden Headline 3",
    "Sweden Headline 4", 
    "Sweden Headline 5", 
    "Sweden Headline 6",
    "Sweden Headline 7",
     "Sweden Headline 8",
      "Sweden Headline 9"
];

const aleagueHeadlines = [
    "A-League Headline 1",
     "A-League Headline 2",
      "A-League Headline 3",
    "A-League Headline 4",
     "A-League Headline 5",
      "A-League Headline 6",
    "A-League Headline 7",
     "A-League Headline 8", 
     "A-League Headline 9"
];

const worldHeadlines = [
    "World Headline 1",
     "World Headline 2",
      "World Headline 3",
    "World Headline 4", 
    "World Headline 5",
     "World Headline 6",
    "World Headline 7", 
    "World Headline 8",
     "World Headline 9"
];

export class ContentArea {
    constructor(containerId, options = {}) {
        this.containerId = containerId;
        this.rows = options.rows || 17;
        this.onCardClick = options.onCardClick || null;
        this.element = null;
        this.wrapper = null;
    }

    /**
     * Initialize the content area component
     */
    async init() {
        console.log('ContentArea initializing...');
        this.element = document.getElementById(this.containerId);
        if (!this.element) {
            throw new Error(`ContentArea container #${this.containerId} not found`);
        }
        this.element.classList.add('content-area');

        // Inject responsive styles
        this.injectStyles();

        this.wrapper = this.element.querySelector('.content-wrapper');
        if (!this.wrapper) {
            this.wrapper = document.createElement('div');
            this.wrapper.className = 'content-wrapper';
            this.element.appendChild(this.wrapper);
        }

        this.render();
        this.attachEventListeners();
    }

    injectStyles() {
        const styleId = 'content-area-responsive-v2';
        if (document.getElementById(styleId)) return;

        const css = `
            /* Prevent page-level horizontal scroll */
            html, body {
                overflow-x: hidden;
                width: 100%;
                margin: 0;
                padding: 0;
            }

            /* Main Container */
            .content-area {
                width: 100%;
                max-width: 100vw;
                overflow-x: hidden;
                box-sizing: border-box;
            }

            .content-wrapper {
                width: 100%;
                max-width: 1200px;
                margin: 0 auto;
                box-sizing: border-box;
            }

            /* Rows */
            .news-row {
                width: 100%;
                margin-bottom: 24px;
                box-sizing: border-box;
            }

            /* Cards Container */
            .row-cards-container {
                display: flex;
                gap: 16px;
                overflow-x: auto;
                padding: 0 16px 16px; /* Bottom padding for shadow/scroll */
                width: 100%;
                box-sizing: border-box;
                
                /* Hide Scrollbars */
                scrollbar-width: none;
                -ms-overflow-style: none;
                
                /* Smooth Scroll & Snap */
                scroll-behavior: smooth;
                scroll-snap-type: x mandatory;
                -webkit-overflow-scrolling: touch;
            }
            
            .row-cards-container::-webkit-scrollbar {
                display: none;
            }

            /* Cards */
            .news-card {
                position: relative;
                flex: 0 0 auto;
                width: 280px;
                max-width: 85vw; /* Responsive width */
                scroll-snap-align: center;
                
                /* Visuals */
                background: #fff;
                border-radius: 8px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                text-decoration: none;
                color: inherit;
                display: flex;
                flex-direction: column;
                transition: transform 0.2s;
            }

            .news-card:hover {
                transform: translateY(-2px);
            }

            .card-image {
                height: 160px;
                width: 100%;
                background-size: cover;
                background-position: center;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: 500;
                text-shadow: 0 1px 2px rgba(0,0,0,0.3);
                border-radius: 8px 8px 0 0;
            }

            .card-content {
                padding: 16px;
            }

            .card-headline {
                margin: 0 0 8px 0;
                font-size: 16px;
                line-height: 1.4;
                font-weight: 600;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            .card-meta {
                margin: 0;
                font-size: 13px;
                color: #666;
            }

            /* Metadata */
            .row-metadata {
                padding: 0 16px 10px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                font-weight: 600;
                color: #888;
                letter-spacing: 0.5px;
            }
            .metadata-logo { margin-right: 8px; }
            .metadata-logo-img {
                height: 24px;
                width: 24px;
                object-fit: contain;
                border-radius: 50%;
            }
            .metadata-flag-img {
                height: 16px;
                width: auto;
                border-radius: 3px;
                box-shadow: 0 1px 2px rgba(0,0,0,0.2);
            }

            /* Scroll Indicator */
            .scroll-indicator {
                position: sticky;
                right: 10px;
                align-self: center;
                flex: 0 0 auto;
                z-index: 10;
                background: rgba(255,255,255,0.95);
                border-radius: 50%;
                width: 40px;
                height: 40px;
                border: 1px solid #eee;
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-left: -20px; /* Pull back slightly */
            }
            
            .scroll-indicator.left {
                right: auto;
                left: 10px;
                margin-left: 0;
                margin-right: -20px;
            }

            .hidden {
                display: none !important;
            }

            /* Mobile Specifics */
            @media (max-width: 768px) {
                .news-card {
                    width: 85vw;
                }
                .row-cards-container {
                    padding-right: 16px; /* Restore padding when button hidden */
                }
            }
        `;

        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    /**
     * Render all news rows
     */
    render() {
        if (!this.wrapper) return;

        this.wrapper.innerHTML = '';
        for (let i = 0; i < this.rows; i++) {
            const row = this.createNewsRow(i);
            this.wrapper.appendChild(row);
        }

        this.wrapper.insertAdjacentHTML('beforeend', `
            <footer class="footer">
                <div class="footer-logo">
                    <img src="/images/logo2.png" alt="" class="logo-icon">
                    <span class="logo-text">footballgirl</span>
                </div>
                <p class="footer-tagline">The Home of Female Football</p>
                <p style="margin-top: 1rem; font-size: 0.85rem; display: flex; gap: 15px; justify-content: center;">
                    <a href="#page=returns" style="color: var(--text-secondary); text-decoration: underline;">Returns & Refunds</a>
                    <a href="#page=terms" style="color: var(--text-secondary); text-decoration: underline;">Terms of Service</a>
                </p>
            </footer>
        `);
    }

    /**
     * Create a single news row
     * Similar to a React component: <NewsRow rowIndex={i} />
     */
    createNewsRow(rowIndex) {
        const row = document.createElement('div');
        row.className = 'news-row';
        row.setAttribute('data-row-index', rowIndex);

        // Add anchor for the first row (UK news)
        if (rowConfig[rowIndex]) {
            row.id = rowConfig[rowIndex].id;
        }

        // Metadata
        const metadata = this.createRowMetadata(rowIndex);
        row.appendChild(metadata);

        // Cards container
        const cardsContainer = this.createCardsContainer(rowIndex);
        row.appendChild(cardsContainer);

        return row;
    }

    /**
     * Create row metadata (logo and flag)
     */
    createRowMetadata(rowIndex) {
        const metadata = document.createElement('div');
        metadata.className = 'row-metadata';
        const country = countries[rowIndex % countries.length];
        
        if (rowConfig[rowIndex]) {
            const config = rowConfig[rowIndex];
            metadata.innerHTML = `
                <img src="${config.logo}" alt="League Logo" class="metadata-logo-img">
                <img src="${config.flag}" alt="Country Flag" class="metadata-flag-img">
            `;
        } else {
            metadata.innerHTML = `
                <div class="metadata-logo">LOGO</div>
                <div class="metadata-flag">${country}</div>
            `;
        }
        return metadata;
    }

    /**
     * Create cards container with scroll functionality
     */
    createCardsContainer(rowIndex) {
        const container = document.createElement('div');
        container.className = 'row-cards-container';
        container.setAttribute('data-row-index', rowIndex);

        // Left Scroll Indicator
        const leftIndicator = this.createScrollIndicator(container, 'left');
        container.appendChild(leftIndicator);

        // Generate 9 cards for every row
        const count = 9;
        
        let prefix = `row-${rowIndex + 1}`;
        if (rowConfig[rowIndex]) {
            prefix = rowConfig[rowIndex].prefix;
        }
        
        for (let i = 0; i < count; i++) {
            const numericIndex = (rowIndex * 9) + i;
            const cardId = `${prefix}-${i + 1}`;
            
            let headline = newsHeadlines[numericIndex % newsHeadlines.length];
            
            // Map row indices to headline arrays
            const customHeadlinesMap = {
                0: wslHeadlines,
                1: nwslHeadlines,
                2: aplHeadlines,
                3: dfbHeadlines,
                4: ligafHeadlines,
                5: serieaHeadlines,
                6: wkHeadlines,
                7: bpiHeadlines,
                8: brasilHeadlines,
                9: ligamxHeadlines,
                10: nwflHeadlines,
                11: uslHeadlines,
                12: weHeadlines,
                13: saffHeadlines,
                14: swedenHeadlines,
                15: aleagueHeadlines,
                16: worldHeadlines
            };

            // Override if custom headline exists
            if (customHeadlinesMap[rowIndex] && customHeadlinesMap[rowIndex][i]) {
                headline = customHeadlinesMap[rowIndex][i];
            }
            
            // Add image logic for all rows based on rowConfig
            let imageUrl = null;
            if (rowConfig[rowIndex] && rowConfig[rowIndex].prefix) {
                const imagePrefix = rowConfig[rowIndex].prefix;
                imageUrl = `images/${imagePrefix}/${i + 1}.jpg`;
            }

            const card = this.createNewsCard(headline, cardId, numericIndex, imageUrl);
            container.appendChild(card);
        }

        // Right Scroll Indicator
        const rightIndicator = this.createScrollIndicator(container, 'right');
        container.appendChild(rightIndicator);

        // Setup scroll behavior
        this.setupScrollBehavior(container);

        return container;
    }

    /**
     * Create a single news card
     * Similar to: <NewsCard headline={headline} index={index} />
     */
    createNewsCard(headline, id, numericIndex, imageUrl = null) {
        const card = document.createElement('a');
        card.href = '#';
        card.className = 'news-card';
        card.setAttribute('data-card-index', id);

        const gradient = cardGradients[numericIndex % cardGradients.length];
        const backgroundStyle = imageUrl ? `background: url('${imageUrl}') center/cover no-repeat;` : `background: ${gradient};`;

        card.innerHTML = `
            <div class="card-image" style="${backgroundStyle}">
                ${imageUrl ? '' : '<span style="opacity: 0.7;">Image Placeholder</span>'}
            </div>
            <div class="card-content">
                <h3 class="card-headline">${headline}</h3>
                <p class="card-meta">Read here..</p>
            </div>
        `;

        return card;
    }

    /**
     * Create scroll indicator button
     */
    createScrollIndicator(container, direction = 'right') {
        const indicator = document.createElement('button');
        indicator.className = `scroll-indicator ${direction}`;
        indicator.setAttribute('aria-label', `Scroll ${direction}`);
        
        const points = direction === 'left' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
        
        indicator.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="${points}"></polyline>
            </svg>
        `;

        indicator.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const scrollAmount = direction === 'left' ? -350 : 350;
            container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        return indicator;
    }

    /**
     * Setup scroll behavior and indicator visibility
     */
    setupScrollBehavior(container) {
        const leftBtn = container.querySelector('.scroll-indicator.left');
        const rightBtn = container.querySelector('.scroll-indicator.right');

        const checkScrollable = () => {
            const isScrollable = container.scrollWidth > container.clientWidth;
            const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 10;
            const isAtStart = container.scrollLeft <= 10;

            // Toggle Left Button
            if (isAtStart) {
                leftBtn?.classList.add('hidden');
            } else {
                leftBtn?.classList.remove('hidden');
            }

            // Toggle Right Button
            if (!isScrollable || isAtEnd) {
                rightBtn?.classList.add('hidden');
            } else {
                rightBtn?.classList.remove('hidden');
            }
        };

        container.addEventListener('scroll', checkScrollable);
        window.addEventListener('resize', checkScrollable);
        setTimeout(checkScrollable, 100);

        // Drag to scroll
        this.setupDragScroll(container);
    }

    /**
     * Setup drag-to-scroll functionality
     */
    setupDragScroll(container) {
        let isDown = false;
        let startX;
        let scrollLeft;

        container.style.cursor = 'grab';

        container.addEventListener('mousedown', (e) => {
            isDown = true;
            container.style.cursor = 'grabbing';
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
        });

        container.addEventListener('mouseleave', () => {
            isDown = false;
            container.style.cursor = 'grab';
        });

        container.addEventListener('mouseup', () => {
            isDown = false;
            container.style.cursor = 'grab';
        });

        container.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 2;
            container.scrollLeft = scrollLeft - walk;
        });

        // Touch support
        let touchStartX = 0;
        let scrollLeftStart = 0;

        container.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].pageX - container.offsetLeft;
            scrollLeftStart = container.scrollLeft;
        }, { passive: true });

        container.addEventListener('touchmove', (e) => {
            if (!touchStartX) return;
            const x = e.touches[0].pageX - container.offsetLeft;
            const walk = (x - touchStartX) * 2;
            container.scrollLeft = scrollLeftStart - walk;
        }, { passive: true });
    }

    /**
     * Attach event listeners
     */
    attachEventListeners() {
        if (this.wrapper) {
            this.wrapper.addEventListener('click', (e) => {
                const card = e.target.closest('.news-card');
                if (card && this.onCardClick) {
                    e.preventDefault();
                    const cardIndex = card.dataset.cardIndex;
                    this.onCardClick(cardIndex, card);
                }
            });
        }
    }
}
